import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

export interface RouteData {
	disableNavigation?: boolean;
	skipWebSocket?: boolean;
	url?: string;
}

@Injectable({ providedIn: 'root' })
export class RouteDataService {
	private routeData$ = new BehaviorSubject<RouteData>({});

	constructor(
		private readonly router: Router,
		private readonly route: ActivatedRoute
	) {
		this.router.events
			.pipe(filter((event) => event instanceof NavigationEnd))
			.subscribe((event: NavigationEnd) => {
				const data = this.getMergedRouteData();
				this.routeData$.next({
					...data,
					url: event.url
				});

			});
	}

	/**
	 * Get merged route data from all activated route segments
	 */
	private getMergedRouteData(): RouteData {
		let data: RouteData = {};
		let currentRoute = this.route.snapshot;

		while (currentRoute) {
			data = { ...data, ...currentRoute.data };
			currentRoute = currentRoute.firstChild;
		}

		return data;
	}

	/**
	 * Check if WebSocket should be skipped for the current route
	 */
	get skipWebSocket(): boolean {
		return !!this.routeData$.value.skipWebSocket;
	}

	/**
	 * Observable for route data changes
	 */
	get data$() {
		return this.routeData$.asObservable();
	}
}
